<h2 mat-dialog-title *ngIf="!isDetail">Copiar Encuesta</h2>
<h2 mat-dialog-title *ngIf="isDetail">{{ nombreEncuesta }}</h2>
<mat-dialog-content class="mat-typography" *ngIf="!isDetail">
  <div class="row">
    <div class="col s12 m12 l12" style="text-align: center;">
      <mat-form-field class="example-full-width input-size">
        <mat-icon matSuffix>search</mat-icon>
        <input type="search" matInput placeholder="Buscar" />
      </mat-form-field>
    </div>
  </div>
  <div class="contenedor-form" *ngIf="loadingDetalle">
    <mat-spinner [diameter]="40" style="margin:0 auto; top:15px;"></mat-spinner>
  </div>
  <div class="row">
    <div class="col s12 m12 l12">
      <div class="contenedor-form" *ngIf="loadingEncuesta">
        <mat-spinner
          [diameter]="100"
          style="margin:0 auto; top:15px;"
        ></mat-spinner>
      </div>
      <mat-list>
        <h3 mat-subheader>Encuestas</h3>
        <mat-list-item
          *ngFor="let encuesta of encuestas"
          (click)="selectEncuesta(encuesta)"
        >
          <!--<mat-list-item (mouseover)="mouseHover(encuesta.id);" (mouseleave)="mouseOut();" *ngFor="let encuesta of encuestas" (click)="selectEncuesta();">-->
          <mat-icon mat-list-icon>list_alt</mat-icon>
          <h4 mat-line>{{ encuesta.valor | uppercase }}</h4>
          <!--<button *ngIf="showBtn==encuesta.id" mat-raised-button color="primary" (click)="selectEdit($event);" id="{{encuesta.id}}">Editar</button>-->
          <button mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-content class="mat-typography" *ngIf="isDetail">
  <div class="row">
    <div class="col s12 m12 l12">
      <button mat-mini-fab (click)="volver();">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>
  </div>
  <div class="row" *ngFor="let bloque of encuestaCopiar">
    <div class="col s12 m12 l12">
      <p class="primary-color">{{ bloque.descripcion }}</p>
      <span *ngFor="let pregunta of bloque.preguntas; let i = index">
        <p style="margin-left: 15px; margin-top: 15px;">{{ [i + 1] }}. ¿{{ pregunta.enunciado }}?</p>
        <span *ngIf="pregunta.opciones">
            <mat-selection-list style="margin-left: 25px;">
                <mat-list-option [disabled]="true" checkboxPosition="before" *ngFor="let opcion of pregunta.opciones">
                  {{opcion.descripcionOpcion}}
                </mat-list-option>
              </mat-selection-list>
        </span>
        <span *ngIf="!pregunta.opciones">
          <mat-form-field style="margin-left: 25px;" class="example-full-width">
            <input matInput readonly="true" type="text" />
          </mat-form-field>
        </span>
      </span>
    </div>
  </div>
</mat-dialog-content>
<div *ngIf="isDetail" mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="copiarEncuesta()">
      <mat-icon>file_copy</mat-icon>
      Copiar
    </button>
  </div>
